/**
 * Rules to determine if the user must declare content itms.
 *
 * 115017 [MP][COL] - To swap steppers sorting order of step 2&3 and use new logic for flow https://ascentsoftware.visualstudio.com/Swift/_workitems/edit/115017
1. If country is in EU
1.1. and ITMATT is set as true SHOW Declaration and send ITMATT info
1.2. and NO ITMATT required HIDE Declaration but continue flow for small Label Use Label API to create small label
2. If country is not in EU
2.1. and ITMATT is set as true SHOW Declaration and send ITMATT info (CN23 Required)
2.2. and NO ITMATT required then don't send ITMATT but show declaration (CN23 Required)

 */

const stepRecipient = 1;
const stepItemtypeCategory = 2;
const stepContentItems = 3;
const stepSender = 4;

const _isRequiresContentItems = (countryId, countries) => {
  const country = countries.find(function (country) {
    return country.id === countryId;
  });
  return !(country.isEUCountry && !country.requireITMATT); //see comment above for rules when to include content items
};

export default {

  afterRecipientGoTo: (countryId, countries) => {
    const isRequiresContentItems = _isRequiresContentItems(countryId, countries);    
    const stepNumber = isRequiresContentItems ? stepItemtypeCategory : stepSender;
    return { stepNumber, isRequiresContentItems };
  },

  beforeSenderGoTo: (countryId, countries) => {
    const isRequiresContentItems = _isRequiresContentItems(countryId, countries);
    const stepNumber = isRequiresContentItems ? stepContentItems : stepRecipient;
    return { stepNumber, isRequiresContentItems };
  }
}